export const Config = {
    serveur : "http://game-api.zeop.re",
    key : "DFG-FGH-YUI-UIO"
}